// Application constant goes here

export const KYCConstants = {
  helpPhoneNumber: "9418132222",
  autoHideDuration: 3500,
  panCharLimit: 10,
  ifscCodeCharLimit: 11,
  accountNumberCharLimit: 18,
  pragathiAppName: 'SEMINIS',
  ENABLE_GST_SECTION: true, // Set to true to enable GST section, false to disable
};

export const KYCRegxConstants = {
  isfcRegx: /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/,
  panRegx: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
};

export const APIResource = {
  IFSC: "/v1/kyc/ifsc/",
  validatePAN: "/v1/kyc/customers/{customerId}/pan",
  panCardOcr: "/v1/kyc/ocr/pan-card",
  bankAccountOcr: "/v1/kyc/ocr/bank-account",
  validateBank: "/v1/kyc/customers/{customerId}/bank-account",
  customerDetails: "/v1/kyc/customers/{customerId}",
  submitKYC: "/v1/kyc/customers/{customerId}",
  uploadCancelledCheque: "/v1/kyc/customers/{customerId}/documents/upload-url",
  documentDownloadUrl: "/v1/kyc/customers/{customerId}/documents/download-url",
  gstCertificateOcr: "/v1/kyc/ocr/gst-certificate",
  validateGst: "/v1/kyc/customers/{customerId}/gst",
};

export const ClientList ={
  'SEMINIS' : '',
  'BRP' : ''
}
